import Swiper, { EffectFade, Autoplay, Pagination } from "swiper"
import "swiper/css/effect-fade"

export default {
  init() {
   
    $(".top-banner__close-btn").on('click', function(){
      $("#top-banner").slideUp();
      $("#top-banner").css('opacity','0');
      $("#top-banner").css('height','0px');
      $("#top-banner").css('display','none');
      $("#top-banner").removeClass('banner-show');
      Cookies.set("banner", true, { expires: 7 })
    });
    if (!Cookies.get("banner")) {
      $("#top-banner").addClass('banner-show');
    }

    const swiper = new Swiper(".swiper-top-banner", {
      modules: [EffectFade, Autoplay, Pagination],
      loop: true,
      pagination: {
        el: '.top-banner__slider-circles',
        type: 'bullets',
        clickable: true
      },
      autoplay: {
        delay: 3000,
      },
      direction: "horizontal",
      effect: "fade",
      fadeEffect: {
        crossFade: true,
      },
    })
  },
}
